import { Typography } from "@mui/material";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import Grid from "@mui/material/Grid";
import TextField from "@mui/material/TextField";
import * as React from "react";
import { Button, useRefresh } from "react-admin";
import sendRequest from "../../dataProvider/sendRequest";
import CustomButtonCancel from "../../unit/CustomButtonCancel";
import CustomButtonSubmit from "../../unit/CustomButtonSubmit";
import CustomDateTextInput from "../../unit/CustomDateTextInput";
import useNotify from "../../unit/useNotify";
import DialogApplicationBaseInfo from "../DialogApplicationBaseInfo";

export default function CustomApproved2DisburseOutHMFormDialog({ ...props }) {
  const { successNotify, errorNotify, infoNotify } = useNotify();
  const { appId, record } = props;
  const [open, setOpen] = React.useState(false);
  const [dateClosing, setdateClosing] = React.useState("");
  const [transferDate, setTransferDate] = React.useState("");
  const [transferAmount, setTransferAmount] = React.useState(
    record?.fundAmount || record?.amountReview
  );
  //formate date to yyyy-mm-dd
  const [todayDate, setTodayDate] = React.useState(
    new Date().toISOString().split("T")[0]
  );
  const refresh = useRefresh();
  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    refresh();
  };

  return (
    <React.Fragment>
      <Button
        id="btn-application-approved-disburseouthm"
        // label="Disbursed outside HM"
        label="Disbursed Offline"
        variant="contained"
        size="medium"
        color="primary"
        sx={{
          marginLeft: "10px",
          width: "auto",
          "&:hover": { bgcolor: "gray" },
        }}
        onClick={handleClickOpen}
      />
      <Dialog
        id="dialog-application-approved-disburseouthm"
        open={open}
        onClose={handleClose}
        fullWidth={true}
        maxWidth="sm"
        PaperProps={{
          component: "form",
          onSubmit: async (event: React.FormEvent<HTMLFormElement>) => {
            event.preventDefault();
            const reqUrl = `applications/actions/approved/disbursementOutSideHM`;
            const formData = new FormData(event.currentTarget);
            var uploadFileId = document.getElementById("uploadFileId") as any;
            if (uploadFileId) {
              formData.append("uploadFileIds", uploadFileId.value);
            }
            const formJson = Object.fromEntries((formData as any).entries());
            console.log("formJson", formJson.transferamount);
            //  transferamount > 0
            if (
              formJson.transferamount <= 0 ||
              formJson.transferamount == undefined ||
              formJson.transferamount == ""
            ) {
              errorNotify("Amount must be greater than 0");
              return false;
            }
            // transferdate is required
            if (
              formJson.transferdate == undefined ||
              formJson.transferdate == ""
            ) {
              errorNotify("Transfer date is required");
              return false;
            }

            const response = await sendRequest(reqUrl, {
              id: appId,
              data: formJson,
            });
            if (
              response &&
              (response.status == "200" || response.code == "200")
            ) {
              successNotify("Data saved successfully");
              handleClose();
            } else {
              errorNotify(response?.message || "Data not saved!");
            }
          },
        }}
      >
        <DialogTitle
          sx={{
            fontWeight: "bold",
            mb: 2,
            borderBottom: "1px solid #e5e5e5",
            color: "#465384",
            textTransform: "uppercase",
          }}
        >
          {/* Disbursed outside Happy Mango */}
          Disbursed Offline
        </DialogTitle>
        <DialogContent>
          <DialogApplicationBaseInfo appId={appId} record={record} />
          <DialogContentText>
            <Typography variant="body1">
              Please check information entered and confirm that the amount was
              disbursed outside of Happy Mango on {todayDate}.
            </Typography>
            <Grid container spacing={2}>
              <Grid item xs={12} sm={4}>
                <TextField
                  id="transferamount"
                  name="transferamount"
                  value={transferAmount}
                  onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                    if (e.target.value != "") {
                      setTransferAmount(e.target.value);
                    }
                  }}
                  label="Amount"
                  fullWidth
                  required
                  variant="outlined"
                  //number
                  type="number"
                  InputLabelProps={{ shrink: true }}
                />
              </Grid>
              <Grid item xs={12} sm={4}>
                <CustomDateTextInput
                  id="transferdate"
                  name="transferdate"
                  value="today"
                  required={true}
                  onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                    if (e.target.value != "") {
                      setTransferDate(e.target.value);
                    }
                  }}
                  variant="outlined"
                />
              </Grid>
            </Grid>
          </DialogContentText>
        </DialogContent>
        <DialogActions sx={{ justifyContent: "space-between" }}>
          <CustomButtonCancel onClick={handleClose} />
          <CustomButtonSubmit
            // label="Disbursed outside HM"
            label="Disbursed Offline"
            color="primary"
            sx={{ width: "auto" }}
          />
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
}
